import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMembershipRules, resetMembershipCreateRule, StateStatus } from '@guryou/redux';

const useMembershipRules = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.membership.membershipRules);
  const create = useSelector(state => state.membership.createMembershipRule);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMembershipRules());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (create.status === StateStatus.LOADED) {
      dispatch(getMembershipRules());
      dispatch(resetMembershipCreateRule());
    }
  }, [dispatch, create.status]);

  return { data: data || [], status, version, entity };
};

export default useMembershipRules;
